const textDefaults = {
  'EN': {
    "intro": "To retrieve your VCA certificate, please provide or check the following information before continuing:",
    "lblVAT": "VAT number",
    "lblFirstName": "First Name",
    "lblLastName": "Last Name", 
    "lblDOB": "Date Of Birth",
    "lblManualUploadUser": "We did not find your VCA certificate online. You can upload one below",
    "lblManualUploadCompany": "We did not find your VCA certificate online. You can upload one or an ISO45001 certificate below",
    "lblQuestionnaireUser": "If you don't have one, you can download our questionnaire",
    "lblQuestionnaireCompany": "If you have neither, you can download our questionnaire",
    "lblDocUploadLineUser": "VCA certificate",
    "lblDocUploadLineCompany": "VCA or ISO45001 certificate",
    "lblDocUploadLineQuestionnaireUser": "VCA or the filled in questionnaire",
    "lblDocUploadLineQuestionnaireCompany": "VCA, ISO45001 certificate or the filled in questionnaire",
    "lblCertificates": "The following certificates were automatically retrieved:",
    "finishedTitle": "Ready to submit",
    "finishedReason": "On submitting, the data you provided will be carefully reviewed and additional checks might be necessary.",
    "expiredError": "Certificate expired or will expire too soon",
  },
  'FR': {
    "intro": "Pour récupérer votre certificat VCA, veuillez fournir ou vérifier les informations suivantes avant de continuer :",
    "lblVAT": "Numéro de TVA", 
    "lblFirstName": "Prénom",
    "lblLastName": "Nom de famille",
    "lblDOB": "Date de naissance",
    "lblManualUploadUser": "Nous n'avons pas trouvé votre certificat VCA en ligne. Vous pouvez télécharger un certificat VCA ci-dessous",
    "lblManualUploadCompany": "Nous n'avons pas trouvé votre certificat VCA en ligne. Vous pouvez télécharger un certificat VCA ou un certificat ISO45001 ci-dessous",
    "lblQuestionnaireUser": "Si vous n'en avez pas, vous pouvez télécharger notre questionnaire",
    "lblQuestionnaireCompany": "Si vous n'avez ni l'un ni l'autre, vous pouvez télécharger notre questionnaire",
    "lblDocUploadLineUser": "Certificat VCA",
    "lblDocUploadLineCompany": "Certificat VCA ou ISO45001",
    "lblDocUploadLineQuestionnaireUser": "Certificat VCA ou le questionnaire rempli",
    "lblDocUploadLineQuestionnaireCompany": "Certificat VCA, ISO45001 ou le questionnaire rempli",
    "lblCertificates": "Les certificats suivants ont été récupérés automatiquement :",
    "finishedTitle": "Prêt à soumettre",
    "finishedReason": "En soumettant, les données que vous avez fournies seront soigneusement examinées et des vérifications supplémentaires pourraient être nécessaires.",
    "expiredError": "Certificat expiré ou expirera trop rapidement",
  },
  'DE': {
    "intro": "Um Ihr VCA-Zertifikat abzurufen, geben Sie bitte die folgenden Informationen ein oder überprüfen Sie sie, bevor Sie fortfahren:",
    "lblVAT": "Umsatzsteuer-Identifikationsnummer",
    "lblFirstName": "Vorname",
    "lblLastName": "Nachname",
    "lblDOB": "Geburtsdatum",
    "lblManualUploadUser": "Wir haben Ihr VCA-Zertifikat online nicht gefunden. Sie können unten ein VCA-Zertifikat hochladen.",
    "lblManualUploadCompany": "Wir haben Ihr VCA-Zertifikat online nicht gefunden. Sie können unten ein VCA-Zertifikat oder ein ISO45001-Zertifikat hochladen",
    "lblQuestionnaireUser": "Wenn Sie keinen haben, können Sie unseren Fragebogen herunterladen",
    "lblQuestionnaireCompany": "Wenn Sie keines von beiden haben, können Sie unseren Fragebogen herunterladen",
    "lblDocUploadLineUser": "VCA-Zertifikat",
    "lblDocUploadLineCompany": "VCA- oder ISO45001-Zertifikat",
    "lblDocUploadLineQuestionnaireUser": "VCA oder der ausgefüllte Fragebogen",
    "lblDocUploadLineQuestionnaireCompany": "VCA-, ISO45001-Zertifikat oder der ausgefüllte Fragebogen",
    "lblCertificates": "Die folgenden Zertifikate wurden automatisch abgerufen:",
    "finishedTitle": "Bereit zur Einreichung",
    "finishedReason": "Bei der Einreichung werden die von Ihnen bereitgestellten Daten sorgfältig geprüft, und es können zusätzliche Überprüfungen erforderlich sein.",
    "expiredError": "Zertifikat abgelaufen oder wird zu bald ablaufen",
  },
  'NL': {
    "intro": "Om uw VCA-certificaat op te halen, dient u de volgende informatie te verstrekken of te controleren voordat u verdergaat:",
    "lblVAT": "BTW-nummer",
    "lblFirstName": "Voornaam",
    "lblLastName": "Achternaam",
    "lblDOB": "Geboortedatum",
    "lblManualUploadUser": "We hebben uw VCA-certificaat niet online gevonden. U kunt hieronder een VCA-certificaat uploaden",
    "lblManualUploadCompany": "We hebben uw VCA-certificaat niet online gevonden. U kunt hieronder een VCA-certificaat of een ISO45001-certificaat uploaden",
    "lblQuestionnaireUser": "Als u er geen heeft, kunt u onze vragenlijst downloaden",
    "lblQuestionnaireCompany": "Als u geen van beide heeft, kunt u onze vragenlijst downloaden",
    "lblDocUploadLineUser": "VCA-certificaat",
    "lblDocUploadLineCompany": "VCA- of ISO45001-certificaat",
    "lblDocUploadLineQuestionnaireUser": "VCA-certificaat of de ingevulde vragenlijst",
    "lblDocUploadLineQuestionnaireCompany": "VCA-certificaat, ISO45001-certificaat of de ingevulde vragenlijst",
    "lblCertificates": "De volgende certificaten zijn automatisch opgehaald:",
    "finishedTitle": "Klaar om in te dienen",
    "finishedReason": "Bij het indienen zullen de door u verstrekte gegevens zorgvuldig worden beoordeeld en kunnen aanvullende controles nodig zijn.",
    "expiredError": "Certificaat verlopen of zal te snel verlopen",
  },
  'PL': {
    "intro": "Aby uzyskać certyfikat VCA, podaj lub sprawdź następujące informacje przed kontynuacją:",
    "lblVAT": "Numer VAT",
    "lblFirstName": "Imię", 
    "lblLastName": "Nazwisko",
    "lblDOB": "Data urodzenia",
    "lblManualUploadUser": "Nie znaleźliśmy Twojego certyfikatu VCA online. Możesz przesłać go poniżej",
    "lblManualUploadCompany": "Nie znaleźliśmy Twojego certyfikatu VCA online. Możesz przesłać poniżej certyfikat VCA lub ISO45001",
    "lblQuestionnaireUser": "Jeśli go nie masz, możesz pobrać nasz kwestionariusz",
    "lblQuestionnaireCompany": "Jeśli nie masz żadnego z nich, możesz pobrać nasz kwestionariusz",
    "lblDocUploadLineUser": "Certyfikat VCA",
    "lblDocUploadLineCompany": "Certyfikat VCA lub ISO45001",
    "lblDocUploadLineQuestionnaireUser": "Certyfikat VCA lub wypełniony kwestionariusz",
    "lblDocUploadLineQuestionnaireCompany": "Certyfikat VCA, ISO45001 lub wypełniony kwestionariusz",
    "lblCertificates": "Następujące certyfikaty zostały automatycznie pobrane:",
    "finishedTitle": "Gotowe do przesłania",
    "finishedReason": "Po przesłaniu, podane przez Ciebie dane zostaną dokładnie sprawdzone, a mogą być potrzebne dodatkowe weryfikacje.",
    "expiredError": "Certyfikat wygasł lub wygaśnie za krótko",
  },
  'BG': {
    "intro": "За да изтеглите сертификата си VCA, моля предоставете или проверете следната информация, преди да продължите:",
    "lblVAT": "ДДС номер",
    "lblFirstName": "Първо име",
    "lblLastName": "Фамилия",
    "lblDOB": "Дата на раждане",
    "lblManualUploadUser": "Не намерихме сертификата ви VCA онлайн. Можете да качите такъв по-долу",
    "lblManualUploadCompany": "Не намерихме сертификата ви VCA онлайн. Можете да качите по-долу сертификат VCA или сертификат ISO45001",
    "lblQuestionnaireUser": "Ако нямате такъв, можете да изтеглите нашия въпросник",
    "lblQuestionnaireCompany": "Ако нямате нито един от тях, можете да изтеглите нашия въпросник",
    "lblDocUploadLineUser": "Сертификат VCA",
    "lblDocUploadLineCompany": "Сертификат VCA или ISO45001",
    "lblDocUploadLineQuestionnaireUser": "Сертификат VCA или попълнения въпросник",
    "lblDocUploadLineQuestionnaireCompany": "Сертификат VCA, ISO45001 или попълнения въпросник",
    "lblCertificates": "Следните сертификати бяха автоматично изтеглени:",
    "finishedTitle": "Готово за изпращане",
    "finishedReason": "При изпращане предоставените от вас данни ще бъдат внимателно прегледани и може да са необходими допълнителни проверки.",
    "expiredError": "Сертификатът е изтекъл или ще изтече твърде скоро",
  },
  'CS': {
    "intro": "Pro získání certifikátu VCA zadejte nebo zkontrolujte následující informace před pokračováním:",
    "lblVAT": "DIČ",
    "lblFirstName": "Jméno",
    "lblLastName": "Příjmení",
    "lblDOB": "Datum narození",
    "lblManualUploadUser": "Online jsme nenašli váš certifikát VCA. Můžete ho nahrát níže",
    "lblManualUploadCompany": "Online jsme nenašli váš certifikát VCA. Můžete nahrát certifikát VCA nebo ISO45001 níže",
    "lblQuestionnaireUser": "Pokud ho nemáte, můžete si stáhnout náš dotazník",
    "lblQuestionnaireCompany": "Pokud nemáte ani jeden z nich, můžete si stáhnout náš dotazník",
    "lblDocUploadLineUser": "Certifikát VCA",
    "lblDocUploadLineCompany": "Certifikát VCA nebo ISO45001",
    "lblDocUploadLineQuestionnaireUser": "Certifikát VCA nebo vyplněný dotazník",
    "lblDocUploadLineQuestionnaireCompany": "Certifikát VCA, ISO45001 nebo vyplněný dotazník",
    "lblCertificates": "Následující certifikáty byly automaticky získány:",
    "finishedTitle": "Připraveno k odeslání",
    "finishedReason": "Při odesílání budou poskytnutá data pečlivě zkontrolována a mohou být nutné další kontroly.",
    "expiredError": "Certifikát vypršel nebo vyprší příliš brzy",
  },
  'DA': {
    "intro": "For at hente dit VCA-certifikat, bedes du angive eller kontrollere følgende oplysninger, før du fortsætter:",
    "lblVAT": "CVR-nummer",
    "lblFirstName": "Fornavn",
    "lblLastName": "Efternavn",
    "lblDOB": "Fødselsdato",
    "lblManualUploadUser": "Vi fandt ikke dit VCA-certifikat online. Du kan uploade et nedenfor",
    "lblManualUploadCompany": "Vi fandt ikke dit VCA-certifikat online. Du kan uploade et VCA-certifikat eller et ISO45001-certifikat nedenfor",
    "lblQuestionnaireUser": "Hvis du ikke har et, kan du downloade vores spørgeskema",
    "lblQuestionnaireCompany": "Hvis du ikke har noget af begge, kan du downloade vores spørgeskema",
    "lblDocUploadLineUser": "VCA-certifikat",
    "lblDocUploadLineCompany": "VCA- eller ISO45001-certifikat",
    "lblDocUploadLineQuestionnaireUser": "VCA eller det udfyldte spørgeskema",
    "lblDocUploadLineQuestionnaireCompany": "VCA, ISO45001-certifikat eller det udfyldte spørgeskema",
    "lblCertificates": "Følgende certifikater blev automatisk hentet:",
    "finishedTitle": "Klar til indsendelse",
    "finishedReason": "Ved indsendelse vil de oplysninger, du har angivet, blive omhyggeligt gennemgået, og der kan være behov for yderligere kontroller.",
    "expiredError": "Certifikat udløbet eller vil udløbe for snart",
  },
  'ES': {
    "intro": "Para recuperar su certificado VCA, proporcione o verifique la siguiente información antes de continuar:",
    "lblVAT": "Número de IVA",
    "lblFirstName": "Nombre",
    "lblLastName": "Apellido",
    "lblDOB": "Fecha de nacimiento",
    "lblManualUploadUser": "No encontramos su certificado VCA en línea. Puede subir uno a continuación",
    "lblManualUploadCompany": "No encontramos su certificado VCA en línea. Puede subir un certificado VCA o ISO45001 a continuación",
    "lblQuestionnaireUser": "Si no tiene uno, puede descargar nuestro cuestionario",
    "lblQuestionnaireCompany": "Si no tiene ninguno, puede descargar nuestro cuestionario",
    "lblDocUploadLineUser": "Certificado VCA",
    "lblDocUploadLineCompany": "Certificado VCA o ISO45001",
    "lblDocUploadLineQuestionnaireUser": "Certificado VCA o el cuestionario completado",
    "lblDocUploadLineQuestionnaireCompany": "Certificado VCA, ISO45001 o el cuestionario completado",
    "lblCertificates": "Se recuperaron automáticamente los siguientes certificados:",
    "finishedTitle": "Listo para enviar",
    "finishedReason": "Al enviar, los datos proporcionados serán revisados cuidadosamente y pueden ser necesarias verificaciones adicionales.",
    "expiredError": "Certificado expirado o expirará demasiado pronto",
  },
  'FI': {
    "intro": "Haeaksesi VCA-todistustasi, anna tai tarkista seuraavat tiedot ennen jatkamista:",
    "lblVAT": "ALV-numero",
    "lblFirstName": "Etunimi",
    "lblLastName": "Sukunimi",
    "lblDOB": "Syntymäaika",
    "lblManualUploadUser": "Emme löytäneet VCA-todistustasi verkosta. Voit ladata sellaisen alla",
    "lblManualUploadCompany": "Emme löytäneet VCA-todistustasi verkosta. Voit ladata alla VCA-todistuksen tai ISO45001-todistuksen",
    "lblQuestionnaireUser": "Jos sinulla ei ole sellaista, voit ladata kyselylomakkeemme",
    "lblQuestionnaireCompany": "Jos sinulla ei ole kumpaakaan, voit ladata kyselylomakkeemme",
    "lblDocUploadLineUser": "VCA-todistus",
    "lblDocUploadLineCompany": "VCA- tai ISO45001-todistus",
    "lblDocUploadLineQuestionnaireUser": "VCA-todistus tai täytetty kyselylomake",
    "lblDocUploadLineQuestionnaireCompany": "VCA, ISO45001-todistus tai täytetty kyselylomake",
    "lblCertificates": "Seuraavat todistukset haettiin automaattisesti:",
    "finishedTitle": "Valmis lähettämään",
    "finishedReason": "Lähettämisessä antamasi tiedot tarkistetaan huolellisesti ja lisätarkistukset voivat olla tarpeen.",
    "expiredError": "Todistus on vanhentunut tai vanhenee liian pian",
  },
  'HR': {
    "intro": "Za dohvat vašeg VCA certifikata, molimo unesite ili provjerite sljedeće informacije prije nastavka:",
    "lblVAT": "PDV broj",
    "lblFirstName": "Ime",
    "lblLastName": "Prezime",
    "lblDOB": "Datum rođenja",
    "lblManualUploadUser": "Nismo pronašli vaš VCA certifikat online. Možete ga uploadati u nastavku",
    "lblManualUploadCompany": "Nismo pronašli vaš VCA certifikat online. Možete uploadati VCA certifikat ili ISO45001 certifikat u nastavku",
    "lblQuestionnaireUser": "Ako ga nemate, možete preuzeti naš upitnik",
    "lblQuestionnaireCompany": "Ako nemate nijedan, možete preuzeti naš upitnik",
    "lblDocUploadLineUser": "VCA certifikat",
    "lblDocUploadLineCompany": "VCA ili ISO45001 certifikat",
    "lblDocUploadLineQuestionnaireUser": "VCA ili popunjen upitnik",
    "lblDocUploadLineQuestionnaireCompany": "VCA, ISO45001 certifikat ili popunjen upitnik",
    "lblCertificates": "Sljedeći certifikati su automatski dohvaćeni:",
    "finishedTitle": "Spremno za slanje",
    "finishedReason": "Pri slanju će se podaci koje ste unijeli pažljivo pregledati i mogu biti potrebne dodatne provjere.",
    "expiredError": "Certifikat je istekao ili će isteći prerano",
  },
  'HU': {
    "intro": "A VCA igazolványa lekéréséhez kérjük, adja meg vagy ellenőrizze a következő információkat, mielőtt folytatja:",
    "lblVAT": "ÁFA-szám",
    "lblFirstName": "Keresztnév",
    "lblLastName": "Vezetéknév",
    "lblDOB": "Születési dátum",
    "lblManualUploadUser": "Nem találtuk meg a VCA igazolványát online. Az alábbiakban feltölthet egyet",
    "lblManualUploadCompany": "Nem találtuk meg a VCA igazolványát online. Az alábbiakban feltölthet egy VCA igazolványt vagy ISO45001 igazolványt",
    "lblQuestionnaireUser": "Ha nincs ilyenük, letöltheti kérdőívünket",
    "lblQuestionnaireCompany": "Ha nincs egyik sem, letöltheti kérdőívünket",
    "lblDocUploadLineUser": "VCA igazolvány",
    "lblDocUploadLineCompany": "VCA vagy ISO45001 igazolvány",
    "lblDocUploadLineQuestionnaireUser": "VCA vagy kitöltött kérdőív",
    "lblDocUploadLineQuestionnaireCompany": "VCA, ISO45001 igazolvány vagy kitöltött kérdőív",
    "lblCertificates": "A következő igazolványokat automatikusan lekérte:",
    "finishedTitle": "Kész az elküldésre",
    "finishedReason": "Az elküldéskor a megadott adatokat gondosan átnézik, és további ellenőrzések szükségesek lehetnek.",
    "expiredError": "Az igazolvány lejárt vagy túl hamar fog lejárni",
  },
  'IT': {
    "intro": "Per recuperare il tuo certificato VCA, si prega di fornire o controllare le seguenti informazioni prima di continuare:",
    "lblVAT": "Partita IVA",
    "lblFirstName": "Nome",
    "lblLastName": "Cognome",
    "lblDOB": "Data di nascita",
    "lblManualUploadUser": "Non abbiamo trovato il tuo certificato VCA online. Puoi caricarne uno qui sotto",
    "lblManualUploadCompany": "Non abbiamo trovato il tuo certificato VCA online. Puoi caricare un certificato VCA o ISO45001 qui sotto",
    "lblQuestionnaireUser": "Se non ne hai uno, puoi scaricare il nostro questionario",
    "lblQuestionnaireCompany": "Se non hai né l'uno né l'altro, puoi scaricare il nostro questionario",
    "lblDocUploadLineUser": "Certificato VCA",
    "lblDocUploadLineCompany": "Certificato VCA o ISO45001",
    "lblDocUploadLineQuestionnaireUser": "Certificato VCA o questionario compilato",
    "lblDocUploadLineQuestionnaireCompany": "Certificato VCA, ISO45001 o questionario compilato",
    "lblCertificates": "I seguenti certificati sono stati recuperati automaticamente:",
    "finishedTitle": "Pronto per l'invio",
    "finishedReason": "Al momento dell'invio, i dati forniti saranno attentamente esaminati e potrebbero essere necessari controlli aggiuntivi.",
    "expiredError": "Certificato scaduto o scadrà troppo presto",
  },
  'NO': {
    "intro": "For å hente VCA-sertifikatet ditt, oppgi eller kontroller følgende informasjon før du fortsetter:",
    "lblVAT": "MVA-nummer",
    "lblFirstName": "Fornavn",
    "lblLastName": "Etternavn",
    "lblDOB": "Fødselsdato",
    "lblManualUploadUser": "Vi fant ikke VCA-sertifikatet ditt online. Du kan laste opp ett nedenfor",
    "lblManualUploadCompany": "Vi fant ikke VCA-sertifikatet ditt online. Du kan laste opp et VCA-sertifikat eller et ISO45001-sertifikat nedenfor",
    "lblQuestionnaireUser": "Hvis du ikke har en, kan du laste ned vårt spørreskjema",
    "lblQuestionnaireCompany": "Hvis du ikke har noen av dem, kan du laste ned vårt spørreskjema",
    "lblDocUploadLineUser": "VCA-sertifikat",
    "lblDocUploadLineCompany": "VCA- eller ISO45001-sertifikat",
    "lblDocUploadLineQuestionnaireUser": "VCA eller utfylt spørreskjema",
    "lblDocUploadLineQuestionnaireCompany": "VCA, ISO45001-sertifikat eller utfylt spørreskjema",
    "lblCertificates": "Følgende sertifikater ble automatisk hentet:",
    "finishedTitle": "Klar til innsending",
    "finishedReason": "Ved innsending vil dataene du har oppgitt bli nøye gjennomgått, og det kan være behov for ytterligere kontroller.",
    "expiredError": "Sertifikat utløpt eller vil utløpe for snart",
  },
  'PT': {
    "intro": "Para recuperar o seu certificado VCA, forneça ou verifique as seguintes informações antes de continuar:",
    "lblVAT": "Número de IVA",
    "lblFirstName": "Primeiro nome",
    "lblLastName": "Sobrenome",
    "lblDOB": "Data de nascimento",
    "lblManualUploadUser": "Não encontramos o seu certificado VCA online. Pode carregar um abaixo",
    "lblManualUploadCompany": "Não encontramos o seu certificado VCA online. Pode carregar um certificado VCA ou ISO45001 abaixo",
    "lblQuestionnaireUser": "Se não tiver um, pode descarregar o nosso questionário",
    "lblQuestionnaireCompany": "Se não tiver nenhum, pode descarregar o nosso questionário",
    "lblDocUploadLineUser": "Certificado VCA",
    "lblDocUploadLineCompany": "Certificado VCA ou ISO45001",
    "lblDocUploadLineQuestionnaireUser": "Certificado VCA ou questionário preenchido",
    "lblDocUploadLineQuestionnaireCompany": "Certificado VCA, ISO45001 ou questionário preenchido",
    "lblCertificates": "Os seguintes certificados foram recuperados automaticamente:",
    "finishedTitle": "Pronto para submeter",
    "finishedReason": "Ao submeter, os dados fornecidos serão cuidadosamente revistos e poderão ser necessárias verificações adicionais.",
    "expiredError": "Certificado expirado ou expirará muito em breve",
  },
  'RO': {
    "intro": "Pentru a recupera certificatul dvs. VCA, vă rugăm să furnizați sau să verificați următoarele informații înainte de a continua:",
    "lblVAT": "Număr TVA",
    "lblFirstName": "Prenume",
    "lblLastName": "Nume de familie",
    "lblDOB": "Data nașterii",
    "lblManualUploadUser": "Nu am găsit certificatul dvs. VCA online. Puteți încărca unul mai jos",
    "lblManualUploadCompany": "Nu am găsit certificatul dvs. VCA online. Puteți încărca un certificat VCA sau un certificat ISO45001 mai jos",
    "lblQuestionnaireUser": "Dacă nu aveți unul, puteți descărca chestionarul nostru",
    "lblQuestionnaireCompany": "Dacă nu aveți niciunul, puteți descărca chestionarul nostru",
    "lblDocUploadLineUser": "Certificat VCA",
    "lblDocUploadLineCompany": "Certificat VCA sau ISO45001",
    "lblDocUploadLineQuestionnaireUser": "Certificat VCA sau chestionar completat",
    "lblDocUploadLineQuestionnaireCompany": "Certificat VCA, ISO45001 sau chestionar completat",
    "lblCertificates": "Următoarele certificate au fost recuperate automat:",
    "finishedTitle": "Gata de trimitere",
    "finishedReason": "La trimitere, datele furnizate vor fi revizuite cu atenție și pot fi necesare verificări suplimentare.",
    "expiredError": "Certificatul a expirat sau va expira prea curând",
  },
  'RU': {
    "intro": "Чтобы получить ваш сертификат VCA, пожалуйста, предоставьте или проверьте следующую информацию перед продолжением:",
    "lblVAT": "Номер НДС",
    "lblFirstName": "Имя",
    "lblLastName": "Фамилия",
    "lblDOB": "Дата рождения",
    "lblManualUploadUser": "Мы не нашли ваш сертификат VCA онлайн. Вы можете загрузить его ниже",
    "lblManualUploadCompany": "Мы не нашли ваш сертификат VCA онлайн. Вы можете загрузить сертификат VCA или ISO45001 ниже",
    "lblQuestionnaireUser": "Если у вас его нет, вы можете скачать наш опросник",
    "lblQuestionnaireCompany": "Если у вас нет ни одного из них, вы можете скачать наш опросник",
    "lblDocUploadLineUser": "Сертификат VCA",
    "lblDocUploadLineCompany": "Сертификат VCA или ISO45001",
    "lblDocUploadLineQuestionnaireUser": "Сертификат VCA или заполненный опросник",
    "lblDocUploadLineQuestionnaireCompany": "Сертификат VCA, ISO45001 или заполненный опросник",
    "lblCertificates": "Следующие сертификаты были автоматически получены:",
    "finishedTitle": "Готово к отправке",
    "finishedReason": "При отправке предоставленные данные будут тщательно проверены, и могут потребоваться дополнительные проверки.",
    "expiredError": "Сертификат истек или истечет слишком скоро",
  },
  'SK': {
    "intro": "Pre získanie vášho certifikátu VCA zadajte alebo skontrolujte nasledujúce informácie pred pokračovaním:",
    "lblVAT": "IČ DPH",
    "lblFirstName": "Meno",
    "lblLastName": "Priezvisko",
    "lblDOB": "Dátum narodenia",
    "lblManualUploadUser": "Našli sme váš certifikát VCA online. Môžete ho nahrať nižšie",
    "lblManualUploadCompany": "Našli sme váš certifikát VCA online. Môžete nahrať certifikát VCA alebo ISO45001 nižšie",
    "lblQuestionnaireUser": "Ak ho nemáte, môžete si stiahnuť náš dotazník",
    "lblQuestionnaireCompany": "Ak nemáte ani jeden, môžete si stiahnuť náš dotazník",
    "lblDocUploadLineUser": "Certifikát VCA",
    "lblDocUploadLineCompany": "Certifikát VCA alebo ISO45001",
    "lblDocUploadLineQuestionnaireUser": "Certifikát VCA alebo vyplnený dotazník",
    "lblDocUploadLineQuestionnaireCompany": "Certifikát VCA, ISO45001 alebo vyplnený dotazník",
    "lblCertificates": "Nasledujúce certifikáty boli automaticky získané:",
    "finishedTitle": "Pripravené na odoslanie",
    "finishedReason": "Pri odosielaní budú poskytnuté údaje starostlivo skontrolované a môžu byť potrebné ďalšie kontroly.",
    "expiredError": "Certifikát vypršal alebo vyprší príliš skoro",
  },
  'SI': {
    "intro": "Za pridobitev vašega VCA certifikata prosimo navedite ali preverite naslednje informacije, preden nadaljujete:",
    "lblVAT": "DDV številka",
    "lblFirstName": "Ime",
    "lblLastName": "Priimek",
    "lblDOB": "Datum rojstva",
    "lblManualUploadUser": "Vašega VCA certifikata nismo našli na spletu. Spodaj lahko naložite enega",
    "lblManualUploadCompany": "Vašega VCA certifikata nismo našli na spletu. Spodaj lahko naložite VCA certifikat ali ISO45001 certifikat",
    "lblQuestionnaireUser": "Če ga nimate, lahko prenesete naš vprašalnik",
    "lblQuestionnaireCompany": "Če nimate nobenega, lahko prenesete naš vprašalnik",
    "lblDocUploadLineUser": "VCA certifikat",
    "lblDocUploadLineCompany": "VCA ali ISO45001 certifikat",
    "lblDocUploadLineQuestionnaireUser": "VCA ali izpolnjen vprašalnik",
    "lblDocUploadLineQuestionnaireCompany": "VCA, ISO45001 certifikat ali izpolnjen vprašalnik",
    "lblCertificates": "Naslednji certifikati so bili avtomatično pridobljeni:",
    "finishedTitle": "Pripravljeno za oddajo",
    "finishedReason": "Ob oddaji bodo podani podatki skrbno pregledani in morda bodo potrebne dodatne preveritve.",
    "expiredError": "Certifikat je potekel ali bo prekmalu potekel",
  },
  'SV': {
    "intro": "För att hämta ditt VCA-certifikat, vänligen ange eller kontrollera följande information innan du fortsätter:",
    "lblVAT": "Momsnummer",
    "lblFirstName": "Förnamn",
    "lblLastName": "Efternamn",
    "lblDOB": "Födelsedatum",
    "lblManualUploadUser": "Vi hittade inte ditt VCA-certifikat online. Du kan ladda upp ett nedan",
    "lblManualUploadCompany": "Vi hittade inte ditt VCA-certifikat online. Du kan ladda upp ett VCA-certifikat eller ISO45001-certifikat nedan",
    "lblQuestionnaireUser": "Om du inte har ett kan du ladda ner vår enkät",
    "lblQuestionnaireCompany": "Om du inte har något av dem kan du ladda ner vår enkät",
    "lblDocUploadLineUser": "VCA-certifikat",
    "lblDocUploadLineCompany": "VCA- eller ISO45001-certifikat",
    "lblDocUploadLineQuestionnaireUser": "VCA eller den ifyllda enkäten",
    "lblDocUploadLineQuestionnaireCompany": "VCA, ISO45001-certifikat eller den ifyllda enkäten",
    "lblCertificates": "Följande certifikat hämtades automatiskt:",
    "finishedTitle": "Redo att skicka",
    "finishedReason": "När du skickar in kommer de data du angivit att granskas noggrant och ytterligare kontroller kan vara nödvändiga.",
    "expiredError": "Certifikatet har gått ut eller kommer att gå ut för snart",
  },
  'TR': {
    "intro": "VCA sertifikanızı almak için lütfen devam etmeden önce aşağıdaki bilgileri sağlayın veya kontrol edin:",
    "lblVAT": "KDV numarası",
    "lblFirstName": "Ad",
    "lblLastName": "Soyad",
    "lblDOB": "Doğum tarihi",
    "lblManualUploadUser": "VCA sertifikanızı çevrimiçi bulamadık. Aşağıdan birini yükleyebilirsiniz",
    "lblManualUploadCompany": "VCA sertifikanızı çevrimiçi bulamadık. Aşağıdan bir VCA sertifikası veya ISO45001 sertifikası yükleyebilirsiniz",
    "lblQuestionnaireUser": "Yoksa anketimizi indirebilirsiniz",
    "lblQuestionnaireCompany": "İkisi de yoksa anketimizi indirebilirsiniz",
    "lblDocUploadLineUser": "VCA sertifikası",
    "lblDocUploadLineCompany": "VCA veya ISO45001 sertifikası",
    "lblDocUploadLineQuestionnaireUser": "VCA veya doldurulmuş anket",
    "lblDocUploadLineQuestionnaireCompany": "VCA, ISO45001 sertifikası veya doldurulmuş anket",
    "lblCertificates": "Aşağıdaki sertifikalar otomatik olarak alındı:",
    "finishedTitle": "Göndermeye hazır",
    "finishedReason": "Gönderirken, sağladığınız veriler dikkatle incelenecek ve ek kontroller gerekebilir.",
    "expiredError": "Sertifika süresi doldu veya çok yakında dolacak",
  },
  'UK': {
    "intro": "Щоб отримати ваш сертифікат VCA, будь ласка, надайте або перевірте наступну інформацію перед продовженням:",
    "lblVAT": "Номер ПДВ",
    "lblFirstName": "Ім'я",
    "lblLastName": "Прізвище",
    "lblDOB": "Дата народження",
    "lblManualUploadUser": "Ми не знайшли ваш сертифікат VCA в інтернеті. Ви можете завантажити його нижче",
    "lblManualUploadCompany": "Ми не знайшли ваш сертифікат VCA в інтернеті. Ви можете завантажити сертифікат VCA або ISO45001 нижче",
    "lblQuestionnaireUser": "Якщо у вас його немає, ви можете завантажити наш опитувальник",
    "lblQuestionnaireCompany": "Якщо у вас немає жодного з них, ви можете завантажити наш опитувальник",
    "lblDocUploadLineUser": "Сертифікат VCA",
    "lblDocUploadLineCompany": "Сертифікат VCA або ISO45001",
    "lblDocUploadLineQuestionnaireUser": "Сертифікат VCA або заповнений опитувальник",
    "lblDocUploadLineQuestionnaireCompany": "Сертифікат VCA, ISO45001 або заповнений опитувальник",
    "lblCertificates": "Наступні сертифікати були автоматично отримані:",
    "finishedTitle": "Готово до відправки",
    "finishedReason": "При відправці надані дані будуть ретельно перевірені, і можуть знадобитися додаткові перевірки.",
    "expiredError": "Сертифікат закінчився або закінчиться надто швидко",
  }
}
;


export function getTextDefaults(lang) {
	return textDefaults[lang.toUpperCase()] || textDefaults.EN;
}

export function getLanguages() {
	return Object.keys(textDefaults);
}